<template>
  <div class="project-summaries">
    <h1>Project Summaries</h1>

    <div>
      <div>
        <div>
          <h3>Total Tasks: {{ items.length }}</h3>
        </div>
        <div>
          <h3>Total Hours: {{ totalHours }}</h3>
        </div>
      </div>
      
      <div class="summaries-table">
        <v-row class="summary-header">
          <v-col>
            <span>Project</span>
          </v-col>
          <v-col cols="3">
            <span>Hours Spent</span>
          </v-col>
          <v-col cols="3">
            <span>Hours Expected</span>
          </v-col>
          <v-col cols="3">
            <span>Cost</span>
          </v-col>
        </v-row>
        <v-row 
          v-for="(project, key) in summaries" :key="key"
          class="summary-row">
          <v-col>
            <span>{{ key }}</span>
          </v-col>
          <v-col cols="3"
            :class="{
              'danger': project.project && project.hours > project.project.quote_hours,
              'warning': project.project && project.project.quote_hours - project.hours < 20,
              'success': project.project && project.hours <= project.project.quote_hours,
            }">
            <span>{{ project.hours }}</span>
          </v-col>
          <v-col cols="3">
            <span>{{ project.project && project.project.quote_hours }}</span>
          </v-col>
          <v-col cols="3" class="cost-summary-col">
            <template v-if="project.project">
              <div>{{ formatCurrency(getProjectCost(project))}}</div>
              <div>{{ formatCurrency(getProjectRevenue(project))}}</div>
              <div class="total">{{ formatCurrency(getProjectRevenue(project) - getProjectCost(project))}}</div>
            </template>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import vue from 'vue';
import { differenceInMinutes } from 'date-fns';

export default vue.extend({
  props: {
    items: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      summaries: {},
      projects: {},
      clients: {},
      totalHours: 0,
    }
  },
  mounted() {
    this.getProjects();
    this.summaries = this.groupBy(this.items, 'project');
  },
  watch: {
    items() {
      this.totalHours = 0;
      this.summaries = this.groupBy(this.items, 'project');
    }
  },
  methods: {
    formatCurrency(value) {
      if (!value) {
        return;
      }

      return value.toLocaleString('en-CA', {
        style: 'currency',
        currency: 'CAD',
      });
    },
    getProjectRevenue(entry) {
      if (!entry.project) {
        return;
      }

      return entry.project.quote_rate * entry.project.quote_hours;
    },
    getProjectCost(entry) {
      if (!entry.project) {
        return;
      }

      return entry.project.quote_rate * entry.hours;
    },
    groupBy(array, key) {
      return array.reduce((result, entry) => {
        (result[entry[key]] = result[entry[key]] || []).push(entry);

        if (!result[entry[key]].hours) {
          result[entry[key]].hours = 0;
        }

        if (!result[entry[key]].project) {
          const match = this.projects[entry[key]];
          console.log("projects", this.projects)
          result[entry[key]].project = match;
        }

        // Calculate total hours
        if (entry.billable && entry.started_at && entry.ended_at) {
          // date format: 2024-01-11T16:00:00-05:00
          const startedAt = new Date(entry.started_at);
          const endedAt = new Date(entry.ended_at);

          if (!(isNaN(startedAt) || isNaN(endedAt))) {
            const hours = differenceInMinutes(endedAt, startedAt) / 60;
            
            result[entry[key]].hours += hours;

            if (!isNaN(hours)) {
              this.totalHours += hours;
            }
          }
        }

        return result;
      }, {});
    },
    async getProjects() {
      try {
        const response = await this.$axios.get('/projects');
        
        this.projects = {};

        // Create a map of projects
        response.data.forEach(project => {
          this.projects[project.id] = project;
          this.projects[project.name] = project;
        });
      } catch (error) {
        console.error(error);
      }
    }
  }
});
</script>